export default __webpack_public_path__ + "224a06e.png";